// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-shell {
  min-height: 100vh;
  display: flex;
  background: #0a0a0a;
}

.app-shell-main {
  flex: 1 1;
  min-width: 0;
  min-height: 100vh;
  overflow-x: hidden;
}

@media (max-width: 768px) {
  .app-shell {
    display: block;
  }

  .app-shell-main {
    min-height: 100vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppShell/AppShell.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".app-shell {\n  min-height: 100vh;\n  display: flex;\n  background: #0a0a0a;\n}\n\n.app-shell-main {\n  flex: 1;\n  min-width: 0;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n@media (max-width: 768px) {\n  .app-shell {\n    display: block;\n  }\n\n  .app-shell-main {\n    min-height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
